// Legacy route — permanently redirects to the unified settings page.
// Kept so that any bookmarked or deep-linked URLs continue to work.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin/media-admin-settings")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/media", replace: true });
  },
  component: () => null,
});
